import { Link } from 'react-router-dom';

import ImgSlot from '@/ui/ImgSlot';
import type { Resident } from '@/types';

import styles from './ArtistHero.module.css';

interface ArtistHeroProps {
  artist: Resident;
  index: number;
  setsCount: number;
}

export default function ArtistHero({ artist, index, setsCount }: ArtistHeroProps) {
  return (
    <>
      <div className={styles.strip}>
        <span className={styles.crumbs}>
          <Link to="/">MOCT</Link>
          <span className={styles.sep}>/</span>
          <Link to="/artists">ARTISTS</Link>
          <span className={styles.sep}>/</span>
          <span>{artist.name}</span>
        </span>
        <span className={styles.live}>
          <i className={styles.pulse} />
          ACTIVE RESIDENT
        </span>
      </div>

      <header className={styles.hero}>
        <div className={styles.heading}>
          <span className={styles.kick}>
            <i className={styles.dot} />/ {artist.role} · SINCE {artist.since}
          </span>
          <h1>{artist.name}</h1>
          <div className={styles.metaRow}>
            <span>
              <span className={styles.lbl}>TAG</span> {artist.tag}
            </span>
            <span>
              <span className={styles.lbl}>HOMETOWN</span> {artist.hometown}
            </span>
            <span>
              <span className={styles.lbl}>BPM</span> {artist.bpm}
            </span>
            <span>
              <span className={styles.lbl}>SETS</span> {setsCount}
            </span>
          </div>
          <p className={styles.bio}>{artist.longBio || artist.bio}</p>
        </div>
        <div className={styles.card}>
          <div className={styles.img}>
            <ImgSlot
              src={artist.portraitUrl}
              alt={artist.name}
              label={`${artist.name} · PORTRAIT`}
              mono
            />
            <span className={styles.stampTl}>/ID {String(index + 1).padStart(3, '0')}</span>
            <span className={styles.stampTr}>
              {artist.role === 'GUEST RESIDENT' ? 'GUEST' : 'RES'}
            </span>
            <span className={styles.stampBl}>SINCE {artist.since}</span>
            <span className={styles.stampBr}>{artist.tag}</span>
          </div>
          <div className={styles.freq}>
            <div className={styles.freqLbl}>
              <span>/ FREQUENCY</span>
              <span>{artist.bpm} BPM</span>
            </div>
            <div className={styles.bars}>
              {Array.from({ length: 32 }, (_, k) => (
                <i
                  key={k}
                  style={{
                    animationDelay: `${(k % 8) * 0.08}s`,
                    height: `${20 + ((k * 53) % 80)}%`,
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
